import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import { cn } from "@heroui/theme";
import React from "react";

interface Props {
  className?: string;
  label?: string;
  fullWidth?: boolean;
}
const FindTalent = ({
  className,
  label = "Find Talent",
  fullWidth = true,
}: Props) => {
  return (
    <Button
      as={Link}
      className={cn(
        "text-white text-sm dark:bg-primary-50 leading-5 tracking-[-0.084px]",
        className,
      )}
      color="primary"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      fullWidth={fullWidth}
      href="/contact-us"
    >
      {label}
    </Button>
  );
};

export default FindTalent;
